exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notificated-bang[data-v-40dde510]:before{content:\"\";position:absolute;top:15px;margin-left:-13px;z-index:1;width:10px;height:10px;border-radius:2px;background:red}", ""]);

// exports
